// extracted by mini-css-extract-plugin
export default {"section":"LogoSlider_section__wdjAF","imgBox":"LogoSlider_imgBox__GVh4p"};